// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeSunbit_titleIcon__3ST3W","inputPhoneContainer":"ViewChargeSunbit_inputPhoneContainer__3DnfO"};